export default __webpack_public_path__ + "static/media/Pan.c7696268.svg";